module.exports = __webpack_public_path__ + "static/media/WaitListScreen.4509660a.png";